import { Types } from "../actions/AutonomousMaintenanceListActions";

const initialState = {
    tasklist: {},
    statusList: {},
    autonomousMaintenanceList: null,
    technicianList: null,
    costCenterList: null,
    mainListByAreaId: null,
    subListByAreaId: null,
    areaList: null,
    error: null,
};

export const AutonomousMaintenanceListReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.SET_TASKS_PAGE_AML:
            return {
                ...state,
                tasklist: action.payload || state.tasklist,
            };
        case Types.SET_STATUS_LIST:
            return {
                ...state,
                statusList: action.payload,
            };
        case Types.SET_AUTONOMOUS_MAINTATENANCE_LIST:
            return {
                ...state,
                autonomousMaintenanceList: action.payload.resultObject,
            };

        case Types.SET_AREA_LIST_AUTONOMOUS:
            return {
                ...state,
                areaList: action.payload.resultObject,
            };

        case Types.SET_TECHNICIAN_LIST:
            return {
                ...state,
                technicianList: action.payload,
            };

        case Types.SET_COST_CENTER_LIST: {
            return {
                ...state,
                costCenterList: action.payload.resultObject,
            };
        }
        case Types.SET_MAIN_LIST_BY_AREA_ID_AUTONOMOUS:
            return {
                ...state,
                mainListByAreaId: action.payload.resultObject,
            };
        case Types.SET_SUB_LIST_BY_AREA_ID_AUTONOMOUS:
            return {
                ...state,
                subListByAreaId: action.payload.resultObject,
            };
        case Types.SHOW_SNACK_MESSAGE:
            return {
                ...state,
                error: action.payload,
            };

        default:
            return state;
    }
};
